import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

export const searchScheduledEmail = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`/api/email-activities/search?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/Activities/api.js